import React from 'react'
import './Community.scss'

const Community = () => {
  return (
    <div className="community-container">
      <div className="WordSection1">
        <p
          className="MsoTitle"
          style={{ marginBottom: '.0001pt', lineHeight: 'normal', pageBreakAfter: 'auto' }}
        >
          <a name="_w6y1y6htaebf" />
          <span lang="EN">Community Policy</span>
        </p>
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            &nbsp;
          </span>
        </p>
        <p className="MsoNormal">
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Effective date: October 27, 2022
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '150%', color: '#312E2B' }}>
            ChessX is becoming one of the largest online chess communities with millions of active
            members representing every country on the planet. Our goal is to create a fun, safe, and
            fair place for all chess fans to enjoy the game.
          </span>
        </p>
        <p className="MsoNormal" style={{ marginBottom: '.25in', lineHeight: '150%' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '150%', color: '#312E2B' }}>
            We encourage all members to treat others how they would like to be treated and to follow
            the specific guidelines below. Players and community members who are unable to follow
            these rules will be subject to warnings, restricted privileges, separated playing pools,
            or even having their accounts closed. We reserve the right to change the Community
            Policy at any time. Compliance with the Community Policy does not constitute guaranteed
            future access to ChessX or use of the Service.
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_afokb19c4vjt" />
          <b>
            <span lang="EN" style={{ fontSize: '16.5pt', lineHeight: '115%', color: '#312E2B' }}>
              Community Conduct
            </span>
          </b>
        </h2>
        <p
          className="MsoNormal"
          style={{
            marginTop: '10.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '.5in',
            textIndent: '-.25in'
          }}
        >
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Be kind, helpful, and forgiving
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            We will not tolerate racism, sexism, bigotry, or violent threats
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Do not abuse, attack, threaten, discriminate, or mistreat other members in any way
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Do not hijack threads, troll, or post distracting or meaningless content
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Do not post spam, advertisements, or copy/paste comments and messages
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Do not excessively promote your club
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Do not publicly debate religious or political topics
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Do not post obscene or pornographic content
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Do not discuss illegal activities
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '0in',
            marginRight: '0in',
            marginBottom: '.25in',
            marginLeft: '.5in',
            textIndent: '-.25in'
          }}
        >
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Do not open more than two accounts (a second, anonymous account is allowed for training
            purposes)
          </span>
        </p>
        <h2 style={{ marginBottom: '.0001pt', pageBreakAfter: 'auto' }}>
          <a name="_8oq1szft108q" />
          <b>
            <span lang="EN" style={{ fontSize: '16.5pt', lineHeight: '115%', color: '#312E2B' }}>
              Sportsmanship
            </span>
          </b>
        </h2>
        <p
          className="MsoNormal"
          style={{
            marginTop: '10.0pt',
            marginRight: '0in',
            marginBottom: '.0001pt',
            marginLeft: '.5in',
            textIndent: '-.25in'
          }}
        >
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Do not abort games frequently
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Do not make your opponents wait unnecessarily
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Do not disconnect or quit without resigning when lost
          </span>
        </p>
        <p className="MsoNormal" style={{ marginLeft: '.5in', textIndent: '-.25in' }}>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' '}
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Do not harass or accuse your opponents
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '0in',
            marginRight: '0in',
            marginBottom: '.25in',
            marginLeft: '.5in',
            textIndent: '-.25in'
          }}
        >
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            ●
            <span style={{ font: '7.0pt "Times New Roman"' }}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          </span>
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '115%', color: '#312E2B' }}>
            Follow Fair Play Policy
          </span>
        </p>
        <p
          className="MsoNormal"
          style={{
            marginTop: '.5in',
            marginRight: '0in',
            marginBottom: '.25in',
            marginLeft: '0in',
            lineHeight: '150%'
          }}
        >
          <span lang="EN" style={{ fontSize: '10.5pt', lineHeight: '150%', color: '#312E2B' }}>
            If you have any questions about our policies, please reach out to our Support Team
            (contact@chessx.app).
          </span>
        </p>
        <p className="MsoNormal">
          <span lang="EN">&nbsp;</span>
        </p>
      </div>
    </div>
  )
}

export default Community
